<template>
  <div id="pageGrua" @click="handleClickOutside">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card class="grua-card elevation-2">
            <!-- Header mejorado -->
            <v-toolbar color="primary" dark flat>
              <v-icon class="mr-2">mdi-account-tie</v-icon>
              <v-toolbar-title v-if="!$vuetify.breakpoint.mdAndDown">Lista de empresas de grúas</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- Búsqueda para escritorio -->
              <v-col cols="3" class="mr-3" v-if="!$vuetify.breakpoint.mdAndDown">
                <v-text-field
                  v-model="filter.search"
                  label="Buscar empresa de grúas..."
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                  rounded
                  single-line
                  filled
                  dense
                  dark
                ></v-text-field>
              </v-col>
              <!-- Búsqueda para móvil -->
              <v-tooltip top v-if="$vuetify.breakpoint.mdAndDown && !showSearch">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click.stop="toggleSearch">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Buscar</span>
              </v-tooltip>
              <v-col cols="12" v-if="showSearch && $vuetify.breakpoint.mdAndDown">
                <v-text-field
                  ref="searchInput"
                  v-model="filter.search"
                  label="Buscar conductor..."
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                  rounded
                  single-line
                  filled
                  dense
                  dark
                  @keydown.esc="showSearch = false"
                ></v-text-field>
              </v-col>

              <!-- Menú de filtros mejorado -->
              <filter-menu
                title="Filtrar grúas"
                :current-filter="currentFilter"
                @canceled="rollbackFilter()"
                @filtered="commitFilter()"
              >
                <v-col dense>
                  <v-row cols="12" sm="6">
                    <v-text-field
                      v-model="filter.company"
                      label="Compañía"
                      clearable
                      outlined
                      dense
                      hide-details="auto"
                      class="mb-4"
                      prepend-inner-icon="mdi-domain"
                    ></v-text-field>
                  </v-row>
                  <v-row cols="12" sm="6">
                    <v-text-field
                      v-model="filter.cif"
                      label="CIF"
                      clearable
                      outlined
                      dense
                      hide-details="auto"
                      class="mb-4"
                      prepend-inner-icon="mdi-identifier"
                    ></v-text-field>
                  </v-row>
                  
                  <!-- Campo de filtro por dealer (solo para colaboradores) 
                  <v-row v-if="$store.getters.HAS_ROLE(['colaborator'])" cols="12">
                    <v-select 
                      v-model="filter.dealer_id" 
                      :items="accessibleDealers" 
                      :loading="loadingAccessibleDealers"
                      item-value="id" 
                      item-text="name" 
                      label="Dealer" 
                      clearable 
                      outlined 
                      dense 
                      hide-details="auto" 
                      class="mb-4"
                      prepend-inner-icon="mdi-store"
                    >
                      <template v-slot:selection="{ item }">
                        <v-icon left small :color="item.is_own ? 'primary' : 'grey'">
                          {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                        </v-icon>
                        {{ item.name }}
                      </template>
                      <template v-slot:item="{ item }">
                        <v-icon left :color="item.is_own ? 'primary' : 'grey'">
                          {{ item.is_own ? 'mdi-home' : 'mdi-store' }}
                        </v-icon>
                        <span>{{ item.name }}</span>
                        <v-chip v-if="item.is_own" x-small class="ml-2" color="primary">Propio</v-chip>
                      </template>
                    </v-select>
                  </v-row>-->
                  
                </v-col>
              </filter-menu>              <!-- Botón para agregar conductor -->
              <v-tooltip top v-if="canCreateGrua">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="showGruaForm(null)" class="mr-2" color="white">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Agregar Conductor</span>
              </v-tooltip>
              <!-- Botón para refrescar -->
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="refreshDataTable" v-on="on" color="white" class="mr-0">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar lista</span>
              </v-tooltip>
              <!-- Formulario de conductor (modal) -->
              <grua-form
                v-if="visibleForm"
                v-model="editItem"
                @save="updateDataTable"
                @cancel="visibleForm = false"
              ></grua-form>
            </v-toolbar>
            <!-- Selector de vista (tarjetas/tabla) -->
            <v-card-actions class="px-4 py-2">
              <div class="text-subtitle-1 font-weight-medium grey--text text--darken-2">
                {{ totalItems }} grúas encontrados
              </div>
              <v-spacer></v-spacer>
              <v-btn-toggle
                v-model="viewMode"
                mandatory
                dense
                color="primary"
              >
                <v-btn value="cards" small>
                  <v-icon small>mdi-view-grid-outline</v-icon>
                  Tarjetas
                </v-btn>
                <v-btn value="table" small>
                  <v-icon small>mdi-table</v-icon>
                  Tabla
                </v-btn>
              </v-btn-toggle>
            </v-card-actions>
            <!-- Vista de tarjetas -->
            <v-card-text v-if="viewMode === 'cards'" class="px-4 pt-0 pb-4">
              <!-- Estado de carga -->
              <v-row v-if="loadingItems">
                <v-col cols="12" sm="6" md="4" lg="3" v-for="n in 8" :key="`skeleton-${n}`">
                  <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                </v-col>
              </v-row>              <!-- Estado sin resultados -->
              <v-row v-else-if="!GRUAS.length" class="text-center py-5">
                <v-col cols="12">
                  <h3 class="text-h5 grey--text text--darken-1 mb-2">No se encontraron grúas</h3>
                  <p class="text-subtitle-1 grey--text mb-6">Intenta cambiar los filtros o añade un nuevo conductor</p>
                  <v-btn v-if="canCreateGrua" color="primary" outlined @click="showGruaForm(null)">
                    <v-icon left>mdi-plus</v-icon>
                    Agregar grúa
                  </v-btn>
                </v-col>
              </v-row>
              <!-- Lista de grúas en tarjetas -->
              <v-row v-else>
                <v-col cols="12" sm="6" md="4" lg="3" v-for="grua in GRUAS" :key="grua.id">
                  <v-card
                    class="grua-card-item h-100"
                    outlined
                    hover
                    @click="viewGruaDetails(grua)"
                  >
                  <v-card-text class="pa-4">
                    <!-- Avatar y estado -->
                    <div class="d-flex mb-4">
                      <v-avatar size="56" color="primary lighten-4" class="mr-3">
                        <v-icon size="32" color="primary">mdi-tow-truck</v-icon>
                      </v-avatar>
                      <div>
                        <div class="subtitle-1 font-weight-bold mb-1">
                          {{ grua.company }}
                        </div>
                      </div>
                    </div>
                    <!-- Información básica -->
                    <v-list dense class="pa-0 transparent">
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-2">
                          <v-icon small color="grey darken-1">mdi-identifier</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            CIF: {{ grua.cif || 'No disponible' }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-2">
                          <v-icon small color="grey darken-1">mdi-phone</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-subtitle>{{ grua.phone || 'No disponible' }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-2">
                          <v-icon small color="grey darken-1">mdi-email</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-subtitle class="text-truncate">{{ grua.email || 'No disponible' }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                    <v-divider></v-divider>                    <!-- Acciones de tarjeta -->
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn v-if="canEditGrua" icon small color="primary" @click.stop="showGruaForm(grua)" title="Editar">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        small
                        color="info"
                        :to="{ name: 'GruaDetail', params: { grua_id: grua.id } }"
                        title="Ver detalles"
                        @click.stop
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>                      
                      <!-- <v-btn
                        v-if="canDeleteGrua"
                        icon
                        small
                        color="red"
                        @click.stop="confirmDeleteGrua(grua)"
                        title="Eliminar"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn> -->
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Paginación en vista de tarjetas -->
              <div class="text-center pt-4" v-if="!loadingItems && GRUAS.length > 0">
                <v-row>
                  <v-col cols="12" class="d-flex justify-center align-center flex-wrap pa-2">
                    <div class="text-center d-flex align-center mr-4">
                      <span class="text-body-2 grey--text text--darken-1">Filas por página:</span>
                      <v-select v-model="pagination.itemsPerPage" :items="footer.itemsPerPageOptions" dense outlined
                        hide-details class="ml-2" style="width: 80px;" @change="onItemsPerPageChange"></v-select>
                    </div>

                    <v-pagination v-model="pagination.page" :length="Math.ceil(totalItems / pagination.itemsPerPage)"
                      :total-visible="7" circle @input="onPageChange"></v-pagination>

                    <span class="text-body-2 grey--text text--darken-1 ml-4">
                      {{ paginationText }}
                    </span>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <!-- Vista de tabla -->
            <v-card-text v-else class="pa-0">
              <v-data-table
                :headers="dynamicHeaders"
                :items="GRUAS"
                :options.sync="pagination"
                :loading="loadingItems"
                :footer-props="footer"
                :key="tableId"
                item-key="id"
                class="elevation-0"
                multi-sort
                @click:row="viewGruaDetails"
                :server-items-length="totalItems"
              >
                <!-- Columna de nombre completo -->
                <template v-slot:item.name="{ item }">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="primary lighten-4" class="mr-2">
                      <v-icon size="20" color="primary">mdi-account-tie</v-icon>
                    </v-avatar>
                    <div>
                      <div>{{ item.name }} {{ item.lastname }}</div>
                      <div class="caption grey--text">
                        {{ getDocumentTypeText(item.document_type) }}: {{ item.document_number }}
                      </div>
                    </div>
                  </div>
                </template>
                <!-- Columna de contacto -->
                <template v-slot:item.contact="{ item }">
                  <div>
                    <div class="d-flex align-center">
                      <v-icon small color="grey darken-1" class="mr-1">mdi-email</v-icon>
                      <span>{{ item.email || 'No disponible' }}</span>
                    </div>
                    <div class="d-flex align-center mt-1">
                      <v-icon small color="grey darken-1" class="mr-1">mdi-phone</v-icon>
                      <span>{{ item.phone || 'No disponible' }}</span>
                    </div>
                  </div>
                </template>
                <!-- Columna de estado -->
                <template v-slot:item.status="{ item }">
                  <v-chip small :color="item.status === STATUS_ENABLED ? 'success' : 'grey'" dark>
                    {{ item.status === STATUS_ENABLED ? 'Activo' : 'Inactivo' }}
                  </v-chip>
                </template>
                
                <!-- Columna de dealer (solo para colaboradores) -->
                <!-- <template v-slot:item.dealer="{ item }">
                  <div class="d-flex align-center">
                    <v-avatar size="24" class="mr-2" v-if="item.dealership">
                      <img v-if="item.dealership.imageUrl && item.dealership.imageUrl.url" 
                           :src="item.dealership.imageUrl.url" 
                           alt="Logo del dealer">
                      <v-icon v-else size="16" :color="item.dealership.is_own ? 'primary' : 'grey'">
                        {{ item.dealership.is_own ? 'mdi-home' : 'mdi-store' }}
                      </v-icon>
                    </v-avatar>
                    <div v-if="item.dealership">
                      <div class="font-weight-medium">{{ item.dealership.name }}</div>
                      <div class="caption grey--text text--darken-1">{{ item.dealership.city }}</div>
                    </div>
                    <div v-else class="grey--text">N/A</div>
                  </div>
                </template> -->
                
                <!-- Columna de acciones -->
                <template v-slot:item.action="{ item }">
                  <div class="d-inline-flex action-buttons">                    
                    <v-tooltip top v-if="canEditGrua">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="primary"
                          @click.stop="showGruaForm(item)"
                          v-on="on"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="info"
                          :to="{ name: 'GruaDetail', params: { grua_id: item.id } }"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver detalles</span>
                    </v-tooltip>                    
                    <!-- <v-tooltip top v-if="canDeleteGrua">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="red"
                          @click.stop="confirmDeleteGrua(item)"
                          v-on="on"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip> -->
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- Diálogo de confirmación mejorado -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline error--text">Confirmar eliminación</v-card-title>
        <v-card-text class="py-4">
          <v-row>
            <v-col cols="auto" class="pr-0">
              <v-avatar color="error" size="48" class="mr-4">
                <v-icon dark>mdi-alert</v-icon>
              </v-avatar>
            </v-col>
            <v-col>
              <p class="mb-1">¿Estás seguro de que deseas eliminar esta empresa de grúas?</p>
              <p class="subtitle-1 font-weight-medium">{{ selectedGrua.company }}</p>
              <p class="caption grey--text" v-if="selectedGrua.cif">
                CIF: {{ selectedGrua.cif }}
              </p>
            </v-col>
          </v-row>
          <p class="caption mt-3 red--text">Esta acción no se puede deshacer.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="error" text @click="deleteGrua" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import FilterMenu from '../../components/FilterMenu'
import DealerService from '../../services/DealerService'

const STATUS_DISABLED = 0
const STATUS_ENABLED = 1

export default {
  components: {
    FilterMenu,
    GruaForm: () => import(/* webpackPrefetch: true */ './GruaForm')
  },

  data: () => ({
    // Vista y carga
    loadingItems: false,
    loadingDelete: false,
    totalItems: 0,
    tableId: 0,
    showSearch: false,
    
    manualViewMode: null,
    // Tabla
    headers: [
      {
        text: 'Compañia',
        value: 'company',
        sortable: true,
        width: '25%'
      },
      {
        text: 'Cif',
        value: 'cif',
        sortable: false,
        width: '15%'
      },
      {
        text: 'Teléfono',
        value: 'phone',
        align: 'center',
        width: '15%'
      },
      {
        text: 'Correo',
        value: 'email',
        align: 'center',
        width: '20%'
      },
      // {
      //   text: 'Dealer',
      //   value: 'dealer',
      //   sortable: false,
      //   align: 'center',
      //   width: '15%'
      // },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '10%'
      }
    ],
    footer: {
      itemsPerPageOptions: [10, 20, 30, 40, 50],
      itemsPerPageText: 'grúas por página:',
      pageText: '{0}-{1} de {2}'
    },

    // Filtro
    filter: {
      search: null,
      status: null,
      company: null,
      cif: null,
      phone: null,
      email: null,
      dealer_id: null,
      document_type: null,
      document_number: null
    },
    currentFilter: {
      search: null,
      status: null,
      company: null,
      cif: null,
      phone: null,
      email: null,
      dealer_id: null,
      document_type: null,
      document_number: null
    },
    // Opciones de filtros
    estados: [
      { name: 'Activo', value: STATUS_ENABLED, icon: 'mdi-check-circle' },
      { name: 'Inactivo', value: STATUS_DISABLED, icon: 'mdi-close-circle' }
    ],
    documentTypes: [
      { text: 'DNI', value: 'DNI', icon: 'mdi-card-account-details' },
      { text: 'Pasaporte', value: 'Pasaporte', icon: 'mdi-passport' },
      { text: 'Licencia', value: 'Licencia', icon: 'mdi-car' },
      { text: 'Otro', value: 'Otro', icon: 'mdi-card-text' }
    ],

    // Formulario
    visibleForm: false,
    editItem: null,
    // Diálogo de confirmación
    dialogDelete: false,
    selectedGrua: {},
    
    // Dealers accesibles (para colaboradores)
    accessibleDealers: [],
    loadingAccessibleDealers: false,
    
    // Constantes
    STATUS_DISABLED,
    STATUS_ENABLED
  }),
  computed: {
    ...mapGetters(['GRUAS', 'CURRENT_USER_ROLES', 'HAS_PERMISSION']),
    viewMode: {
      get() {
        // Si el usuario cambió manualmente la vista, usar esa
        if (this.manualViewMode) {
          return this.manualViewMode
        }
        // Detectar dispositivo y retornar vista por defecto
        if (this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.mdAndUp) {
          return 'table'
        }
        return 'cards'
      },
      set(value) {
        // Permitir cambio manual de vista
        this.manualViewMode = value
      }
    },

    // Headers dinámicos basados en el rol del usuario
    dynamicHeaders() {
      let headers = [
        {
          text: 'Compañia',
          value: 'company',
          sortable: true,
          width: '25%'
        },
        {
          text: 'Cif',
          value: 'cif',
          sortable: false,
          width: '15%'
        },
        {
          text: 'Teléfono',
          value: 'phone',
          align: 'center',
          width: '15%'
        },
        {
          text: 'Correo',
          value: 'email',
          align: 'center',
          width: '20%'
        }
      ]
      
      // Agregar columna de dealer solo para colaboradores
      const isColaborator = this.$store.getters.HAS_ROLE(['colaborator'])
      console.log('Es colaborador:', isColaborator)
      
      // if (isColaborator) {
      //   headers.push({
      //     text: 'Dealer',
      //     value: 'dealer',
      //     sortable: false,
      //     align: 'center',
      //     width: '15%'
      //   })
      //   console.log('Columna dealer agregada a headers')
      // }
      
      headers.push({
        text: 'Acciones',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '10%'
      })
      return headers
    },
    
    pagination: {
      get: function () {
        return this.$store.getters.GRUAS_PAG
      },
      set: function (value) {
        this.$store.commit('SET_GRUAS_PAG', value)
      }
    },
    paginationText () {
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage + 1
      const end = Math.min(start + this.pagination.itemsPerPage - 1, this.totalItems)
      return `${start}-${end} de ${this.totalItems}`
    },
    searchTerm () {
      return this.filter.search
    },
    totalPages () {
      return Math.ceil(this.totalItems / this.pagination.itemsPerPage)
    },
    canManageGruas () {
      return !this.CURRENT_USER_ROLES.includes('mechanic')
    },

    // Permisos de grúas
    canCreateGrua() {
      return this.HAS_PERMISSION('crear_grua')
    },

    canEditGrua() {
      return this.HAS_PERMISSION('editar_grua')
    },

    canDeleteGrua() {
      return this.HAS_PERMISSION('eliminar_grua')
    }
  },

  methods: {
    loadData () {
      this.loadingItems = true
      
      // Preparar parámetros de filtro
      let filterParams = { ...this.filter }
      
      // Si es colaborador y tiene dealer seleccionado, usar el filtro especial colaborador_dealer_filter
      // if (this.$store.getters.HAS_ROLE(['colaborator']) && this.filter.dealer_id) {
      //   filterParams.colaborador_dealer_filter = this.filter.dealer_id
      //   // Remover el dealer_id del filtro ya que usamos colaborador_dealer_filter
      //   delete filterParams.dealer_id
      // }
      // Si es colaborador, filtrar solo por su dealer
    if (this.$store.getters.HAS_ROLE(['colaborator'])) {
      const userDealerId = this.$store.getters.CURRENT_USER?.dealer?.id
      if (userDealerId) {
        filterParams.colaborador_dealer_filter = userDealerId
      }
      // Elimina cualquier filtro de dealer manual
      delete filterParams.dealer_id
    } else if (this.filter.dealer_id) {
      // Si no es colaborador pero hay filtro manual, úsalo
      filterParams.colaborador_dealer_filter = this.filter.dealer_id
      delete filterParams.dealer_id
    }
      
      this.$store.dispatch('LOAD_GRUAS', filterParams).then(result => {
        this.totalItems = result
        // Asegurarse de que la página actual es válida
        const maxPage = Math.ceil(result / this.pagination.itemsPerPage)
        if (this.pagination.page > maxPage && maxPage > 0) {
          this.pagination.page = maxPage
        }
        this.loadingItems = false
      }).catch(error => {
        console.error('Error al cargar grúas:', error)
        this.$toast.error('Error al cargar las empresas de grúas')
        this.loadingItems = false
      })
    },
    
    async loadAccessibleDealers () {
      if (!this.$store.getters.HAS_ROLE(['colaborator'])) {
        return // Solo cargar para colaboradores
      }

      try {
        this.loadingAccessibleDealers = true
        const response = await DealerService.getMyAccessibleDealers()
        
        // Verificar la estructura de la respuesta
        let dealersArray = []
        if (response.data && response.data.data && Array.isArray(response.data.data.data)) {
          dealersArray = response.data.data.data
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          dealersArray = response.data.data
        } else if (response.data && Array.isArray(response.data)) {
          dealersArray = response.data
        }
        
        this.accessibleDealers = dealersArray
      } catch (error) {
        console.error('Error al cargar dealers accesibles:', error)
        this.$toast.error('Error al cargar la lista de dealers')
      } finally {
        this.loadingAccessibleDealers = false
      }
    },
    debouncedLoadData: _.debounce(function () {
      this.loadData()
    }, 500),
    updateDataTable ({ insert }) {
      this.visibleForm = false
      if (insert) {
        this.totalItems++
      }
      this.refreshDataTable()
      this.$toast.success(insert ? 'Empresa de grúas creada con éxito' : 'Empresa de grúas actualizada con éxito')
    },
    refreshDataTable () {
      this.tableId++
      this.loadData()
    },

    // Filtros
    commitFilter () {
      for (const key in this.currentFilter) {
        this.currentFilter[key] = this.filter[key]
      }
      this.loadData()
    },
    rollbackFilter () {
      for (const key in this.currentFilter) {
        this.filter[key] = this.currentFilter[key]
      }
    },

    // Acciones
    showGruaForm (item) {
      this.editItem = item ? { ...item } : null
      this.visibleForm = true
    },
    viewGruaDetails (grua) {
      this.$router.push({
        name: 'GruaDetail',
        params: { grua_id: grua.id }
      })
    },
    toggleSearch () {
      this.showSearch = !this.showSearch
      if (this.showSearch) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
        })
      }
    },
    handleClickOutside (event) {
      const searchInput = this.$refs.searchInput
      if (searchInput && !searchInput.$el.contains(event.target)) {
        this.showSearch = false
      }
    },
    deleteGrua () {
      this.loadingDelete = true
      this.$store.dispatch('DELETE_GRUA', this.selectedGRUA).then(() => {
        this.dialogDelete = false
        this.loadingDelete = false
        this.$toast.success('Conductor eliminado con éxito')
        this.refreshDataTable()
      }).catch(error => {
        console.error('Error al eliminar conductor:', error)
        this.$toast.error('Error al eliminar las empresas de grúas')
        this.loadingDelete = false
      })
    },
    confirmDeleteGrua (item) {
      this.selectedGrua = item
      this.dialogDelete = true
    },
    // Utilidades
    getDocumentTypeText (type) {
      if (!type) return 'Doc'
      return type
    },
    onPageChange (page) {
      // Actualizar la página en la paginación
      this.pagination.page = page
      // Forzar la carga de datos inmediatamente después del cambio de página
      this.loadData()
    },
    onItemsPerPageChange (perPage) {
      // Actualizar items por página en la paginación
      this.pagination.itemsPerPage = perPage
      // Asegurarse de volver a la primera página al cambiar elementos por página
      this.pagination.page = 1
      // Forzar la carga de datos
      this.loadData()
    }
  },
  watch: {
    pagination: {
      handler (newVal, oldVal) {
        // Verificar si realmente cambió algo importante que requiera recargar
        const relevantPropsChanged = ['page', 'itemsPerPage', 'sortBy', 'sortDesc'].some(
          prop => !_.isEqual(newVal[prop], oldVal?.[prop])
        )
        // Solo recargar si hay cambios relevantes y no estamos en medio de una carga
        if (relevantPropsChanged && !this.loadingItems && !this.isInitializing) {
          this.loadData()
        }
      },
      deep: true
    },
    searchTerm () {
      this.debouncedLoadData()
    },
    manualViewMode (newVal, oldVal) {
      // Incrementar tableId cuando cambiamos a vista de tabla para forzar re-renderizado
      if (newVal === 'table' && oldVal === 'cards') {
        this.$nextTick(() => {
          this.tableId++
          setTimeout(() => {}, 100)
        })
      }
    }
  },
  async created () {
    // Bandera para evitar recarga durante la inicialización
    this.isInitializing = true
    
    // Cargar dealers accesibles si es colaborador
    await this.loadAccessibleDealers()
    
    this.loadData()
    // Desactivar la bandera de inicialización después de la carga inicial
    this.$nextTick(() => {
      this.isInitializing = false
    })
  }
}
</script>

<style scoped>
.grua-card {
  border-radius: 8px;
  overflow: hidden;
}

.grua-card-item {
  transition: box-shadow 0.2s ease-in-out, transform 0.2s ease;
}

.grua-card-item:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
}

.action-buttons button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.action-buttons button:hover {
  opacity: 1;
}

.search-input-mobile {
  max-width: 200px;
}

/* Animación para nuevos elementos */
@keyframes highlight {
  0% {
    background-color: rgba(var(--v-primary-base), 0.1);
  }
  100% {
    background-color: transparent;
  }
}

.new-item {
  animation: highlight 2s ease-in-out;
}
</style>
